import { createAsyncThunk } from '@reduxjs/toolkit'
import { BomItemAttachmentsController } from 'services/APIs/InternalAPI/AttachmentAPI'
import { ShowException } from 'store/Application/appActions'
import { getContext } from 'store/getContext'
import { newProjectActions } from '../newProjectReducer'

export const uploadAttachments = createAsyncThunk<any, any, { state: any }>(
  'bomItem/uploadAttachments',
  async (
    { bomItemId, attachments }: { bomItemId: string; attachments: Array<File> },
    thunkAPI
  ) => {
    const { partyId, projectId } = getContext(thunkAPI.getState)
    const api = new BomItemAttachmentsController(partyId, projectId)

    try {
      return await api.UploadFiles(bomItemId, attachments, (progress) =>
        thunkAPI.dispatch(
          newProjectActions.uploadProgress({
            operation: 'bomItem/uploadAttachments/' + bomItemId,
            progress,
          })
        )
      )
    } catch (err) {
      ShowException('project', err)
      return thunkAPI.rejectWithValue(err)
    }
  }
)
